import { IAbstractRecord } from '@models';
import {
  CertificateItem,
  Production_CertificateDetailsOutputInput,
} from '../medical-certificate-drawer';
import DateService from '@services/DateService';

export function mapToMedicalGroupPolicyListingData(
  data: Production_CertificateDetailsOutputInput,
  planDetails: IAbstractRecord
) {
  if (!data || !data.Items || data.Items.length === 0) {
    return {
      pagedItems: [],
      pageSize: 10,
      pageNumber: 1,
      totalCount: 0,
    };
  }

  const pagedItems = data.Items.map((item: IAbstractRecord) => {
    const subline = `${planDetails.sublineExternalCode || ''} - ${planDetails.sublineName || ''}`;
    const plan = `${planDetails.planExternalCode || ''} - ${planDetails.planName || ''}`;
    const certificatePricingOption = item?.certificatePricingOption?.[0];
    const currencySymbol =
      certificatePricingOption?.pricingOptionCurrency?.Symbol || '';

    return {
      subline,
      plan,
      policyClass: item?.certificatePolicyMedical?.class?.Title,
      insuredName: item?.certificatePolicyPersons?.[0]?.fullName,
      insuredAge: DateService?.getAge(
        item?.certificatePolicyPersons?.[0]?.dateOfBirth
      ),
      sumInsured: certificatePricingOption?.sumInsured,
      netPremium: certificatePricingOption?.netPremium,
      costAndCharges:
        certificatePricingOption?.policyCostAmount +
        certificatePricingOption?.chargesAmount +
        certificatePricingOption?.tpaFeesTotalAmount,
      taxes:
        certificatePricingOption?.fixedStampAmount +
        certificatePricingOption?.proportionalStampAmount +
        certificatePricingOption?.municipalityTaxAmount,
      totalPremium: certificatePricingOption?.totalPremium,
      effectiveDate: item?.effectiveDate,
      Currency: currencySymbol,
      //status: item.status,
    };
  });

  return {
    pagedItems,
    pageSize: 10,
    pageNumber: 1,
    totalCount: pagedItems.length,
  };
}

export function getCertificateDetailsOutputInput(
  data: Production_CertificateDetailsOutputInput
) {
  return data.Items.map((item: any) => ({
    clauseText: item.clauseText,
    effectiveDate: item.effectiveDate,
    certificatePolicyPlanCovers: item.certificatePolicyPlanCovers
      ? item.certificatePolicyPlanCovers.map((cover: any) => {
          const { __typename, ...cleanCover } = cover;
          return cleanCover;
        })
      : [],
    certificatePricingOption: item.certificatePricingOption
      ? item.certificatePricingOption.map((option: any) => {
          const {
            __typename,
            pricingOptionCurrency,
            fixedStampCurrency,
            ...restOption
          } = option;
          return {
            ...restOption,
            pricingOptionCurrency: pricingOptionCurrency
              ? pricingOptionCurrency.Code
              : null,
            fixedStampCurrency: fixedStampCurrency
              ? fixedStampCurrency.Code
              : null,
          };
        })
      : [],
    certificatePolicyPersons: item.certificatePolicyPersons
      ? item.certificatePolicyPersons.map((person: any) => {
          const { __typename, ...cleanPerson } = person;
          return cleanPerson;
        })
      : [],
    certificatePolicyMedical: item.certificatePolicyMedical
      ? (() => {
          const {
            __typename,
            class: medicalClass,
            ...restMedical
          } = item.certificatePolicyMedical;
          return {
            ...restMedical,
            class: medicalClass ? medicalClass.Code : null,
          };
        })()
      : {},
    certificateInsuredPricingOptionMedical:
      item.certificateInsuredPricingOptionMedical
        ? item.certificateInsuredPricingOptionMedical.map((option: any) => {
            const { __typename, coverClass, coverLevel, ...restOption } =
              option;
            return {
              ...restOption,
              coverClass: coverClass ? coverClass.Code : null,
              coverLevel: coverLevel ? coverLevel.Code : null,
            };
          })
        : [],
  }));
}
